import React, {Component} from 'react';
import injectsheet from 'react-jss';
import {
    Row,
    Col,
} from 'reactstrap'

const styles = {
    info: {
        textAlign: 'center',
        position: 'relative',
        paddingTop: '25px',
        '@media screen and (max-width: 767px)':{
            marginLeft: '3%',
            marginRight: '2%',
        },
        '& h1':{
            color: '#ea9044',
            marginBottom: '3%',
            '@media screen and (max-width: 767px)':{
                fontSize: '1.6rem',
            },
        },
        '& h4':{
            color: '#91230c',
            marginBottom: '4%',
        },
        '& p':{
            fontSize: '1.1rem',
            textAlign: 'justify',
            marginTop: '2%',
            fontFamily: '"Open Sans", "Helvetica", Arial, sans-serif',
            '@media screen and (max-width: 767px)':{
                fontSize: '0.9rem',
            },
        },
        '& .notifications':{
            maxHeight: '400px',
            overflowY:'scroll',
            '@media screen and (max-width: 767px)':{
                fontSize: '0.9rem',
            },
        }
    }
}

class Info extends Component {
    render() {
        const {classes} = this.props;
        return (
            <div className={classes.info}>
                <h1>Net In Life Sciences</h1>
                <Row>
                    <Col md={{size: 6, offset: 1}}>
                        <h4>About Us</h4>
                        <p>We are emerging as a potential of excellence institution in <strong>Ranchi, Jharkhand</strong>, providing a platform for <strong>NET-aspirants</strong> to crack <strong>JRF-NET (CSIR), GATE-Life sciences, IIT-JAM, TIFR and PH.D. entrance examinations</strong> of reputed universities in India. We provide Exhaustive Classes with regular tests, Test series and Mock tests, Study materials, Techniques to crack the exams. Soon we will start Correspondence Courses. We have best faculties from university departments and Institutions.</p>
                        <p>Established with the vision to impart right mix of training and education for students of <strong>M.Sc. in Life Sciences, Zoology, Botany, Microbiology and Biotechnology</strong>. Our teaching methods are result oriented and we prepared scientific pattern to prepare them.</p>
                    </Col>
                    <Col md="4">
                        <h4>Notifications & News</h4>
                        <div className="notifications list-group">
                            {/*<span className="list-group-item list-group-item-action list-group-item-info">Online Live classes through Zoom : <strong>Registration for new batch is on. Call: +91-7004600534</strong>.</span>*/}
                            <a className="list-group-item list-group-item-action list-group-item-success" href="https://forms.gle/FRB2Rx3afHCfbdiK8" target="_blank" rel="noopener noreferrer">
                            Admission open for: <strong> June 2025 and December 2024</strong>.
                            </a>
                            <a className="list-group-item list-group-item-action list-group-item-success" target="_blank" rel="noopener noreferrer">
                             Ms. Vidya Kumari, CSIR UGC NET selected for PhD project in BARC, Mumbai in <strong> June 2024</strong>.
                            </a>
                            <span className="list-group-item list-group-item-action ">Online and Offline  Test Series : February 5th 2023.</span>
                            <span className="list-group-item list-group-item-action "> New Batch for JRF/NET Life Sciences: 1st February, 2023.</span>
                            <span className="list-group-item list-group-item-action ">Ms. Kanika Kumari, JRF/NET CSIR - Selected for Assistant Professor of Zoology, VBU, Hazaribag.</span>
                            <span className="list-group-item list-group-item-action ">Ms. Puja Soni, UGC NET - Selected for Assistant Professor, SKMU, Dumka.</span>
                            <span className="list-group-item list-group-item-action">Mr. Aman Kumar, CSIR JRF/NET - Assistant Professor (contractual basis), Marwari College, Ranchi</span>
                            <span className="list-group-item list-group-item-action">Mr. Akash Kumar, UGC-NET - Working as Assistant Professor of zoology, Annada College, Hazaribag</span>
                            {/*<a className="list-group-item list-group-item-action" href="http://59.163.216.84:8080/new_jrf/" target="_blank" rel="noopener noreferrer">Apply for the CSIR-UGC JRF/NET Examination-Dec, 2019.</a>*/}
                            <a className="list-group-item list-group-item-action" href="/pdf/Pre-Ph.D._Examination-2018_(Ranchi_University,_Ranchi).pdf" target="_blank" rel="noopener noreferrer">Pre-Ph.D. Examination of Ranchi University -2019</a>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default injectsheet(styles)(Info);

